import { ComputedRef, onMounted, Ref } from 'vue'
import { useEventListener } from '@vueuse/core'

/**
 * Displays a browser warning when navigating away from a page if there are changes
 * on a page that have not been saved.
 */
export default function useNavigateWarning(hasBeenEdited: Ref<boolean> | ComputedRef<boolean>) {
  onMounted(() =>
    useEventListener(window, 'beforeunload', (event) => {
      if (hasBeenEdited.value) {
        event.preventDefault()
        event.returnValue = ''
      }
    }),
  )
}
